import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../@types/RootState';

export type GetStoreFamilyClusterModalPaginationState = {
  activePage: number;
  displayLength: number;
};

const initialState: GetStoreFamilyClusterModalPaginationState = {
  activePage: 0,
  displayLength: 25,
};

const slice = createSlice({
  name: 'getStoreFamilyClusterModal/pagination',
  initialState,
  reducers: {
    SET_GET_STORE_FAMILY_CLUSTER_MODAL_PAGINATION: (_state, { payload }: PayloadAction<GetStoreFamilyClusterModalPaginationState>) => payload,
    UPDATE_GET_STORE_FAMILY_CLUSTER_MODAL_PAGINATION: (state, { payload }: PayloadAction<Partial<GetStoreFamilyClusterModalPaginationState>>) => {
      return {
        ...state,
        ...payload,
      };
    },
    SET_GET_STORE_FAMILY_CLUSTER_MODAL_DISPLAY_LENGTH: (state, { payload }: PayloadAction<number>) => {
      return {
        ...state,
        displayLength: payload,
      };
    },
    SET_GET_STORE_FAMILY_CLUSTER_MODAL_ACTIVE_PAGE: (state, { payload }: PayloadAction<number>) => {
      return {
        ...state,
        activePage: payload,
      };
    },
    RESET_GET_STORE_FAMILY_CLUSTER_MODAL_PAGINATION: () => initialState,
  },
});

export const {
  SET_GET_STORE_FAMILY_CLUSTER_MODAL_PAGINATION,
  UPDATE_GET_STORE_FAMILY_CLUSTER_MODAL_PAGINATION,
  SET_GET_STORE_FAMILY_CLUSTER_MODAL_DISPLAY_LENGTH,
  SET_GET_STORE_FAMILY_CLUSTER_MODAL_ACTIVE_PAGE,
  RESET_GET_STORE_FAMILY_CLUSTER_MODAL_PAGINATION,
} = slice.actions;

export const selectorGetStoreFamilyClusterModalPagination = (state: RootState) => {
  return state.getStoreFamilyClusterModalReducer.pagination;
};

export default slice.reducer;
